import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNotifications } from './NotificationsProvider';

export default function DevicePushStatus() {
  const { t } = useTranslation();
  const { deviceStatus, refreshDeviceStatus, enablePush, openPushSettings } = useNotifications();
  const [busy, setBusy] = useState(false), [failed, setFailed] = useState(false);
  useEffect(() => { void refreshDeviceStatus?.(); }, [refreshDeviceStatus]);
  if (!deviceStatus) return null;
  const { platform, permission, registration, available, installRequired } = deviceStatus;
  // The capability check is not an unavailable-device error. Keep initial
  // loading silent so a warning does not flash above the switches.
  if (available == null) return null;
  // Permission checks and registration run in the background. Rendering those
  // intermediate states inserts/removes a row above the notification switches.
  const key = platform === 'web' && installRequired ? 'webInstallRequired'
    : platform === 'web' && permission === 'unsupported' ? 'deviceBrowser' : !available ? (platform === 'web' ? 'webUnavailable' : 'deviceUnavailable')
    : permission === 'denied' ? (platform === 'ios' ? 'permissionDeniedIOS' : platform === 'android' ? 'permissionDeniedAndroid' : 'permissionDeniedWeb')
      : registration === 'error' ? 'registrationFailed' : null;
  const settings = available && permission === 'denied' && ['ios', 'android'].includes(platform);
  // Account preferences can already be on while this installation has never
  // asked permission. Always offer an explicit connection, without status copy
  // during permission checks or registration.
  const retry = available && permission !== 'denied' && (busy || ['unregistered', 'error'].includes(registration));
  if (!key && !retry) return null;
  const action = async () => {
    setBusy(true); setFailed(false);
    try { await (settings ? openPushSettings() : enablePush()); }
    catch (error) { if (!['PUSH_PERMISSION_CANCELLED', 'PUSH_PERMISSION_DENIED', 'PUSH_SESSION_CHANGED'].includes(error.message)) setFailed(true); }
    finally { setBusy(false); }
  };
  return <div className="settings-push-status" role="status" aria-live="polite">
    {key && <p>{t(`notifications:${key}`)}</p>}
    {failed && key !== 'registrationFailed' && <p>{t('notifications:registrationFailed')}</p>}
    {(settings || retry) && <button type="button" onClick={action} disabled={busy}>
      {t(`notifications:${settings ? 'openDeviceSettings' : 'connectDevice'}`)}
    </button>}
  </div>;
}
